import React, { useContext, useEffect, useRef, useState } from 'react';
import dayjs from 'dayjs';

import { Link, Grid, TextField, Paper } from '@material-ui/core';
import Typography from '@material-ui/core/Typography'
import { Alert, AlertTitle } from '@material-ui/lab';

import FireDataContext from '../../../services/firebase/FireDataContext';
import MemberMiniMenu from '../../members/menus/MemberMiniMenu';
import MuiSwitch from '../../../app/common/ui/MuiSwitch';
import Spacer from '../../../app/common/ui/Spacer';

const MailPage = () => {
    const db = useContext(FireDataContext);
    const [mail, setMail] = useState();
    const [showText, setShowText] = useState(false);
    const searchRef = useRef('');
    const [filter, setFilter] = useState();

    useEffect(() => {
        const unsubscribe = db.subscribe({
            path: 'mail',
            hook: data => {
                setMail(data.filter(m => m.ts && m.delivery).sort((a, b) => b.ts - a.ts));
            }
        });

        return unsubscribe;
    }, [db])

    if (!mail) return <></>;

    const handleSearchChange = () => {
        setFilter(searchRef.current.value || '');
    }

    return (
        <MemberMiniMenu>
            <Alert severity="info" variant="filled">
                <AlertTitle>Recent email status</AlertTitle>
                Green SUCCESS means the mail was sent. Red anything means something went wrong
            </Alert>
            <Spacer />
            <Grid container spacing={1}>
              <Grid item xs={12} lg={3}>
                  <TextField
                    label="Search"
                    inputRef={searchRef}
                    onChange={handleSearchChange}
                    variant="standard"
                    fullWidth
                  />
              </Grid>
              <Grid item style={{ marginLeft: 'auto'}}>
                  <MuiSwitch value={showText} label="Show email message text" onChange={setShowText} />
              </Grid>
            </Grid>
            <Spacer />

            {
                mail?.filter(m => {
                    const query = new RegExp(filter, 'i');
                    return query.test(JSON.stringify(m));
                }).map(m => {
                    const color = m.delivery.state === 'SUCCESS' ? 'green' : 'red';
                    const ts = dayjs(m.ts).format('YYYY-MM-DD HH:mm:ss');
                    const to = `To: ${m.to}`;
                    const cc = m.cc ? ` cc: ${m.cc}` : ``;

                    return <Paper key={m.id} style={{ marginBottom: '0.5rem', padding: '1rem'}}>
                        <Typography variant="subtitle2" color="initial">{ts} <span style={{ color }}>{m.delivery.state}</span></Typography>
                        <Typography variant="body2">{to}{cc}</Typography>
                        <Typography variant="body2">Subject: {m.message.subject}</Typography>
                        <Spacer space='0.5rem' />
                        {showText && <Typography variant="body2">{m.message.text}</Typography>}
                        <Spacer space='0.5rem' />
                        <Typography variant="caption">User ID: {m.uid?.slice(0,4)} Mail ID: {m.id}</Typography>
                        <div>
                        {
                            m.message.attachments?.map((a, index) => {
                                var text = `Attachment ${index + 1}`;
                                if (/quotes/i.test(a.path)) text = 'Quote';
                                if (/terms/i.test(a.path)) text = 'Terms & Conditions';
                                if (/inv/i.test(a.path)) text = 'Invoice';
                                if (/booking/i.test(a.path)) text = 'Booking Form';

                                return <div key={`a-${index}`}>
                                    <Link  href={a.path} target="_blank" rel="noreferrer">{text}</Link>
                                    </div>
                            })
                        }
                        </div>
                         
                        </Paper>
                })
            }
        </MemberMiniMenu>
    );
};

const MailPagePath = '/admin/mail';

export {
    MailPagePath
}

export default MailPage;